import { ca } from '@cian/analytics';
import { TSource } from 'shared/types/newbuildingBrokerOfferBooking';

type TPlaceType = 'main_button' | 'gallery' | 'gallery_pop_up' | 'label_pop_up';

const SOURCE_TO_ANALYTICS_TYPE: Record<TSource, TPlaceType> = {
  offer_card_main_button: 'main_button',
  offer_card_gallery_banner: 'gallery',
  offer_card_gallery_pop_up: 'gallery_pop_up',
  offer_card_label_pop_up: 'label_pop_up',
};

export const trackBookingButtonClick = (gaLabel: string, source: TSource) => {
  const placeType = SOURCE_TO_ANALYTICS_TYPE[source];

  const extra: Record<TPlaceType, boolean> = {
    main_button: false,
    gallery: false,
    gallery_pop_up: false,
    label_pop_up: false,
  };

  extra[placeType] = true;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Booking_popup_open_floating_block',
    category: 'Card',
    label: gaLabel,
    useLastProducts: true,
    page: {
      extra,
    },
  });
};
